const prefix = 'LABORATORY_';

export const LaboratoryActionTypes = {
  SET_INITIAL_STORE: `${prefix}SET_INITIAL_STORE`,
  GET_SERVICE_TYPES: `${prefix}GET_SERVICE_TYPES`,
  SET_SERVICE_TYPES: `${prefix}SET_SERVICE_TYPES`,
  SET_SELECTED_SERVICE: `${prefix}SET_SERVICE_ID`,
  SET_RECIPIENTS_LIST: `${prefix}SET_RECIPIENTS_LIST`,
  SET_APPLICANT_NAME: `${prefix}SET_APPLICANT_NAME`,
  SET_APPLICANT_CODE: `${prefix}SET_APPLICANT_CODE`,
  STORE_LAB_DATA: `${prefix}STORE_LAB_DATA`,
  SET_CLIENT_INFO: `${prefix}SET_CLIENT_INFO`,
  SET_TEST_DESCRIPTION: `${prefix}SET_TEST_DESCRIPTION`,
  SET_SELECTED_GENDER: `${prefix}SET_SELECTED_GENDER`,
  SET_APPLICANT_LAST_NAME: `${prefix}SET_APPLICANT_LAST_NAME`,
  SET_STORE_LOADING: `${prefix}SET_STORE_LOADING`,
  CHECK_DATA_VALIDATION: `${prefix}CHECK_DATA_VALIDATION`,
  SET_INPUT_ERROR: `${prefix}SET_INPUT_ERROR`,
  GET_QUERY_PARAMS: `${prefix}GET_QUERY_PARAMS`,
  SET_CLIENT_SUGGESTED_TYPE: `${prefix}SET_CLIENT_SUGGESTED_TYPE`,
  SET_CLIENT_SUGGESTED_TIME: `${prefix}SET_CLIENT_SUGGESTED_TIME`,
  SET_CLIENT_SUGGESTED_RANGE: `${prefix}SET_CLIENT_SUGGESTED_RANGE`,
  SET_SHOPPING_CART_INITIAL_STATE: `${prefix}SET_SHOPPING_CART_INITIAL_STATE`,
  SET_PRESCRIPTION_TEXT: `${prefix}SET_PRESCRIPTION_TEXT`,
  SET_PRESCRIPTION_FILE: `${prefix}SET_PRESCRIPTION_FILE`,
  UPLOAD_PRESCRIPTION_FILE: `${prefix}UPLOAD_PRESCRIPTION_FILE`,
  STORE_PRESCRIPTION_DATA: `${prefix}STORE_PRESCRIPTION_DATA`,
  SET_PRESCRIPTION_INITIAL: `${prefix}SET_PRESCRIPTION_INITIAL`,
  SET_CHECKOUT_LOADING: `${prefix}SET_CHECKOUT_LOADING`,
  SET_CITY_MODAL: `${prefix}SET_CITY_MODAL`,
  SET_PRESCRIPTION_TERMS: `${prefix}SET_PRESCRIPTION_TERMS`,
};

const setInitialStore = (data: { hashedLabId: string, hashedServiceTypeId: string, hashedCityId: string, laboratoryData: Array<object>, serviceTypeTitle: string, serviceTypeSlug: string }) => ({ type: LaboratoryActionTypes.SET_INITIAL_STORE, data: data });
const setSelectedService = (data: { selectServiceId: string | undefined, orderCount: number, selectedServiceDetail: { title: string | undefined, price: number | undefined, priceAffix: string | undefined }, totalPrice: number | undefined }) => ({ type: LaboratoryActionTypes.SET_SELECTED_SERVICE, data: data });
const getLaboratoryData = (data: { hashedCityId: string, selectedCity: any }) => ({ type: LaboratoryActionTypes.GET_SERVICE_TYPES, data: data });
const setRecipientsList = (data: { id: string, text: string, recipientsValidation: boolean }) => ({ type: LaboratoryActionTypes.SET_RECIPIENTS_LIST, data: data });
const setApplicantName = (data: { applicantName: string }) => ({ type: LaboratoryActionTypes.SET_APPLICANT_NAME, data: data });
const setApplicantCode = (data: { applicantCode: string }) => ({ type: LaboratoryActionTypes.SET_APPLICANT_CODE, data: data });
const storeLabData = () => ({ type: LaboratoryActionTypes.STORE_LAB_DATA });
const setTestDescription = (data: { selectedServiceDescription: any }) => ({ type: LaboratoryActionTypes.SET_TEST_DESCRIPTION, data: data });
const setGender = (data: { gender: string }) => ({ type: LaboratoryActionTypes.SET_SELECTED_GENDER, data: data });
const setApplicantLastName = (data: { applicantLastName: string }) => ({ type: LaboratoryActionTypes.SET_APPLICANT_LAST_NAME, data: data });
const checkDataValidation = () => ({ type: LaboratoryActionTypes.CHECK_DATA_VALIDATION });
const setInputError = (data: { key: string }) => ({ type: LaboratoryActionTypes.SET_INPUT_ERROR, data: data });
const getQueryParams = (data: { hashedLabId: string, selectServiceId: string, serviceSubTypeId: string, orderCount: number, serviceTypeTitle: string, serviceTypeSlug: string }) => ({ type: LaboratoryActionTypes.GET_QUERY_PARAMS, data: data });
const setClientSuggestedType = (data: { clientSuggestedType: string }) => ({ type: LaboratoryActionTypes.SET_CLIENT_SUGGESTED_TYPE, data: data });
const setClientSuggestedTime = (data: { clientSuggestedTime: string }) => ({ type: LaboratoryActionTypes.SET_CLIENT_SUGGESTED_TIME, data: data });
const setClientSuggestedRange = (data: { clientSuggestedRange: string }) => ({ type: LaboratoryActionTypes.SET_CLIENT_SUGGESTED_RANGE, data: data });
const setShoppingCartInitialState = () => ({ type: LaboratoryActionTypes.SET_SHOPPING_CART_INITIAL_STATE });
const setPrescriptionText = (data: { prescriptionText: string }) => ({ type: LaboratoryActionTypes.SET_PRESCRIPTION_TEXT, data: data });
const setPrescriptionFile = (data: { prescriptionFile: object }) => ({ type: LaboratoryActionTypes.SET_PRESCRIPTION_FILE, data: data });
const uploadPrescriptionFile = () => ({ type: LaboratoryActionTypes.UPLOAD_PRESCRIPTION_FILE });
const storePrescriptionData = () => ({ type: LaboratoryActionTypes.STORE_PRESCRIPTION_DATA });
const setPrescriptionInitial = () => ({ type: LaboratoryActionTypes.SET_PRESCRIPTION_INITIAL });
const setCheckoutLoading = (data: {loading: boolean}) => ({ type: LaboratoryActionTypes.SET_CHECKOUT_LOADING, data: data });
const setCityModal = (data: {labId?: string, slug?: string, open: boolean}) => ({ type: LaboratoryActionTypes.SET_CITY_MODAL, data: data });
const setPrescriptionTerms = (data: {prescriptionTerms: boolean}) => ({ type: LaboratoryActionTypes.SET_PRESCRIPTION_TERMS, data: data });

export const LaboratoryActions = {
  setSelectedService: setSelectedService,
  getLaboratoryData: getLaboratoryData,
  setInitialStore: setInitialStore,
  setRecipientsList: setRecipientsList,
  setApplicantName: setApplicantName,
  setApplicantCode: setApplicantCode,
  storeLabData: storeLabData,
  setTestDescription: setTestDescription,
  setGender: setGender,
  setApplicantLastName: setApplicantLastName,
  checkDataValidation: checkDataValidation,
  setInputError: setInputError,
  getQueryParams: getQueryParams,
  setClientSuggestedType: setClientSuggestedType,
  setClientSuggestedTime: setClientSuggestedTime,
  setClientSuggestedRange: setClientSuggestedRange,
  setShoppingCartInitialState: setShoppingCartInitialState,
  setPrescriptionText: setPrescriptionText,
  setPrescriptionFile: setPrescriptionFile,
  uploadPrescriptionFile: uploadPrescriptionFile,
  storePrescriptionData: storePrescriptionData,
  setPrescriptionInitial: setPrescriptionInitial,
  setCheckoutLoading: setCheckoutLoading,
  setCityModal: setCityModal,
  setPrescriptionTerms: setPrescriptionTerms,
};

